export default __webpack_public_path__ + "src/images/icon_zoom_progress-d2a267.png";